<template>
    <div class="menu-sorting product-list-appearance-select-container">
        <div class="menu-group">
            <span class="menu-sorting-label">{{ __('Megjelenítés') }}:</span>

            <div class="inline-block">
                <button :class="{'active': currentAppearance === 2}"
                        @click="changeAppearance(2)"
                >
                    2
                </button>

                <span>|</span>

                <button :class="{'active': currentAppearance === 4}"
                        @click="changeAppearance(4)"
                >
                    4
                </button>

                <span>|</span>

                <button :class="{'active': currentAppearance === 6}"
                        @click="changeAppearance(6)"
                >
                    6
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppearanceSelect',

    props: {
        initAppearance: {
            type: Number,
            required: true,
            default: () => 4,
        },
    },

    data() {
        return {
            currentAppearance: this.initAppearance,
        }
    },

    methods: {
        changeAppearance(appearance) {
            const container = document.querySelector('.region-products')

            container.classList.remove('listitem-row-2')
            container.classList.remove('listitem-row-4')
            container.classList.remove('listitem-row-6')

            container.classList.add('listitem-row-' + appearance)

            if (appearance === 2) {
                this.setLargestSrcsetImages()
            }

            this.currentAppearance = appearance
            this.$emit('update', appearance)
        },

        setLargestSrcsetImages() {
            const pictureElements = document.querySelectorAll(".product-image")

            pictureElements.forEach(pictureElement => {
                const img = pictureElement.querySelector("img");
                const sources = pictureElement.querySelectorAll("source");

                let largestSrc = "";
                let largestWidth = 0;

                sources.forEach(source => {
                    const srcset = source.getAttribute("srcset");

                    if (! srcset || srcset === '') {
                        return
                    }

                    const candidates = srcset.split(", ");

                    candidates.forEach(candidate => {
                        const [url, width] = candidate.split(" ");
                        const widthValue = parseInt(width, 10);

                        if (widthValue > largestWidth) {
                            largestWidth = widthValue;
                            largestSrc = url;
                        }
                    });
                })

                if (largestSrc) {
                    const timestamp = new Date().getTime();
                    img.src = `${largestSrc}?t=${timestamp}`;

                    const newImg = img.cloneNode(true);
                    pictureElement.replaceChild(newImg, img);
                }
            })
        },
    },
}
</script>

<style lang="scss">
.product-list-appearance-select-container {
    display: block;

    button {
        background: transparent;
        border: none;
        outline: none;
        color: #000;

        &.active {
            color: #b2d630;
        }
    }

    @media (max-width: 960px) {
        display: none;
    }
}
</style>
